import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaDumbbell } from 'react-icons/fa';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex items-center justify-center px-6">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-600">
            404
          </h1>
          <h2 className="text-3xl font-bold text-white mb-4">Page Not Found</h2>
          <p className="text-gray-300 mb-8 max-w-md mx-auto">
            Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white px-8 py-3 rounded-lg font-bold transition-all transform hover:scale-105 flex items-center justify-center space-x-2"
          >
            <FaHome />
            <span>Back to Portfolio</span>
          </Link>
          
          <Link
            to="/gym-management"
            className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white px-8 py-3 rounded-lg font-bold transition-all transform hover:scale-105 flex items-center justify-center space-x-2"
          >
            <FaDumbbell />
            <span>Gym Management</span>
          </Link>
        </div>

        <div className="mt-12 text-gray-400 text-sm">
          <p>Developed by Sabarisan P - Front End Developer</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;